import React from 'react';

import Association from './association';

import type { Deal } from 'bundles/crm/associations/types';

interface Props {
  deal: Deal;
}

export default function DealAssociation({ deal, ...props }: Props) {
  return (
    <Association
      {...props}
      header={deal.displayName}
      path={deal.path}
      subheader={[deal.dealType, deal.stage].join(' / ')}
    />
  );
}
